<template>
    <div>
        <textarea v-model="form.note" rows="4" placeholder="Notes internes, remarques techniques..." class="w-full rounded-lg border border-gray-300 focus:outline-none text-sm p-3" id="inp-note"></textarea>

        <div class="mt-4">
            <input-file class="w-full" v-model="form.doc_url" :preview="false" key-name="note_doc" />
            <div v-if="form.doc_url">
                <a :href="form.doc_url" target="_blank" class="text-red-600 hover:underline font-medium flex items-center mt-2">
                    <i class="fas fa-file-alt mr-2"></i> Voir le document attaché
                </a>
            </div>
        </div>

        <div class="mt-4 flex justify-start">
            <button @click="addNote" :disabled="loadingAddNote" class="bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg transition flex items-center gap-2">
                <i v-if="loadingAddNote" class="fas fa-spinner fa-spin"></i>
                <span><i class="fas fa-plus mr-1"></i> Ajouter la note</span>
            </button>
        </div>

        <!-- Liste des notes -->
        <div class="mt-4 border-t mt-4 pt-4">
            <h4 class="text-md font-semibold mb-2 text-gray-800">Historique des notes</h4>
            <div v-if="loadingGetNotes" class="text-gray-500">Chargement des notes...</div>
            <div v-else-if="notes.length === 0" class="text-gray-500">Aucune note disponible.</div>
            <div v-for="(note, index) in notes" :key="'note-' + index" class="mb-2 p-3 bg-gray-50 rounded-lg border border-gray-200">
                <p class="text-lg text-gray-800 mb-1 font-bold">{{ note.note }}</p>
                <div v-if="note.doc_url"><a :href="note.doc_url" target="_blank" class="text-xs text-red-600 hover:underline font-light flex items-center mb-2"><i class="fas fa-file-alt mr-2"></i> Consulter le document</a></div>
                <p class="text-xs text-gray-500">Ajouté le {{ note.created_at | momentDateTime }}</p>
                <p class="text-xs text-gray-500">Par {{ note.author.prenom + ' ' + note.author.nom }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        clientId: {
            required: true
        },
    },
    data() {
        return {
            form: {
                note: '',
            },
            notes: [],

            loadingGetNotes: false,
            loadingAddNote: false,
        }
    },
    filters: {
        momentDate(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY')
            }
            return '-'
        },
        momentDateTime(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY HH:mm')
            }
            return '-'
        }
    },
    methods: {
        async getNotes() {
            this.loadingGetNotes = true;
            let response = await this.$request.post('/clients/get-notes', {
                client_id: this.clientId,
            });
            this.notes = response
            this.loadingGetNotes = false;
        },

        async addNote() {
            const validation = this.$inpError([
                'inp-note:required',
            ]);

            if (!validation) {
                this.$toast.error('Formulaire invalide')
                return
            }

            this.loadingAddNote = true;
            await this.$request.post('/clients/add-note', {
                client_id: this.clientId,
                note: this.form.note,
                doc_url: this.form.doc_url,
            });

            this.form.note = '';
            this.form.doc_url = null;
            await this.getNotes();
            this.loadingAddNote = false;
        }
    },
    mounted () {
        this.getNotes();
    },
}
</script>

<style lang="scss" scoped>

</style>